module.exports = __webpack_public_path__ + "img/mb-opera.b849f646.svg";